import packageInfo from '../../../package.json';

export const REPO_NAME = packageInfo.name;

/*
 * Application-wide environment variable constants
 * Add these to the appropriate .env file (ex. use .env.local to override these locally)
 * NOTE: must prepend with 'REACT_APP_' in the .env files but will have that prefix stripped before being added to process.env
 */

export const {
  ACTIVATION_API_HOST,
  GVR_HOST,
  MEDIA_API_HOST,
  REGISTRY_RETAILER_API_HOST,
  REGISTRY_CORE_API_HOST,
  TK_HOST,
  WEDDINGS_API_HOST,
  WEDDINGS_API_KEY,
  WEDDING_WEBSITE_DESIGNS_URL,
  WEDDING_WEBSITE_GRAPHQL_ENDPOINT,
  MAGENTO_API_HOST,
  REGISTRY_ITEM_GATEWAY_API_HOST,
  TRANSACTIONAL_ITEMS_API_HOST,
  REGISTRY_SHOPPING_GRAPHQL_ENDPOINT,
  MEMBERSHIP_HOST,
  UNION_MEMBERSHIP_API_KEY,
  TRACKING_API_HOST,
  CASH_API_HOST,
  GIFTS_API_HOST,
  COLLECTIONS_CAROUSEL_COLLECTION_ID,
  USER_STATE_GRAPHQL_HOST,
  STRIPE_FILES_API_HOST,
  STRIPE_PUBLIC_API_KEY,
  STRIPE_V2_CORE_API_VERSION,
  TRANSACTIONAL_COLLECTION_ID,
  POPULAR_GIFTS_CATEGORY_EXCLUSIONS,
} = process.env;

const isDevelopment = process.env.NODE_ENV === 'development';
let yrHost = TK_HOST;

if (isDevelopment) {
  yrHost = `https://${process.env.DEV_HOST}:${process.env.DEFAULT_PORT}`;
}

export const RPV_COOKIE_NAME = '_regact_rpv';
export const COMPLEMENTARY_RECS_COOKIE_NAME = 'complementary_recs_gift_count';
export const WWS_MANAGE_REGISTRY_COOKIE_NAME =
  'wws_manage_registry_dismissible_alert';
export const ZEN_DESK_HELP_URL = 'https://theknot.zendesk.com';
export const HELP_CENTER_URL = 'https://helpcenter.theknot.com/hc/en-us';
export const ACTIVATION_API_TOKEN_HEADER = 'membership-session-token';
export const GIFT_CARD_HELP_URL =
  'https://helpcenter.theknot.com/hc/en-us/articles/17836584838036-Where-is-my-Gift-Card';

// femr specific
export const YR_HOST = yrHost;
export const ONBOARDING_WELCOME_URL = isDevelopment
  ? `${yrHost}/onboarding/welcome`
  : `${yrHost}/registry/onboarding/welcome`;
export const REGISTRY_LANDING_PAGE_URL = isDevelopment
  ? `${yrHost}`
  : `${yrHost}/registry`;
export const CHECKLIST_URL = isDevelopment
  ? `${yrHost}/checklist`
  : `${yrHost}/registry/checklist`;
export const YOUR_REGISTRY_URL = isDevelopment
  ? `${yrHost}/manage-registry`
  : `${yrHost}/registry/manage-registry`;

// tkrs specific
export const COLLECTIONS_LISTING_PAGE_URL = `${TK_HOST}/registry/store/collections`;
export const TRENDING_PRODUCTS_PLP_URL = `${TK_HOST}/registry/store/trending-products`;
export const JUST_ADDED_PRODUCTS_PLP_URL = `${TK_HOST}/registry/store/just-added`;
export const POPULAR_GIFTS_PLP_URL = `${TK_HOST}/registry/store/popular-gifts`;
export const BRANDS_LANDING_PAGE_URL = `${TK_HOST}/registry/store/brands`;

export const CATEGORY_PRODUCT_FACETS = {
  CATEGORY_IDS: 'category_ids',
};
export const POPULAR_GIFTS_CATEGORY_EXCLUSIONS_IDS = POPULAR_GIFTS_CATEGORY_EXCLUSIONS.split(
  ',',
);

export const VENMO_LOGO_URL =
  'https://media-api.xogrp.com/images/0fd58c45-eb6d-40b0-bb36-e4bdf298f0fa';
export const ARROW_TWO_WAY_ICON_URL =
  'https://media-api.xogrp.com/images/87a9e4e0-37b9-442d-bf2e-280ad816bca9';
export const STRIPE_BANK_ICON_URL =
  'https://media-api.xogrp.com/images/c33e6521-a63b-4515-b364-7425f92ca382';
